import React from 'react';

const About = () => {
  return (
    <div className="about">
      <h1>About This App</h1>
      <p>This is a simple to-do app to organize and keep tract of our tasks.</p>
      <p>Version 1.0.0</p>
    </div>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/components/about/About.js